
// custom hook to fetch service call list

import { useEffect, useState, useContext } from "react";


// app config importation
import { AUTH_TOKEN_NAME } from "../../config/appConf.js";


// urls importation
import { urls } from "../../api-urls/api-urls.js";

// react router dom import
import { useNavigate } from "react-router-dom";


// userContext importation
import { UserContext } from "../../context/UserContext.jsx";
import { LangContext } from "../../context/LangContext.jsx";


// constants
import { UrlClient } from "../../components/constants/constants.js";






export const useFetchListCalls = () => {


  // state definition
  const [listServ, setListServ] = useState([]);
  const [controller, setController] = useState(null);
  const [state, setState] = useState({ isLoading: false, dataVisible: false, msg: "", notFound: false, filterModal: false });

  const { user } = useContext(UserContext);
  const { lang } = useContext(LangContext);

  const navigate = useNavigate();

  // abrir el modal para filtrar
  const handleOpenCloseFilter = () => {
    setState((val) => ({ ...val, filterModal: !state.filterModal }));
  };


  // funcion para solicitar la data al servidor
  const fetchDataServ = async () => {

    const abortCont = new AbortController();

    setController(abortCont);


    const END_POINT = `${urls.listCalls}/${user?.CodCliente}?lang=${lang}&urlC=${UrlClient}`;

    const AUTH_TOKEN = localStorage.getItem(AUTH_TOKEN_NAME);

    try {
      setState((val) => ({ ...val, isLoading: true }));
      const response = await fetch(END_POINT, {
        headers: {
          "Authorization": AUTH_TOKEN,
          "Content-Type": "application/json"
        },
        signal: abortCont.signal
      });

      const data = await response.json();

      if (response.status === 200) {
        setListServ(data?.listServ);
        setState((val) => ({ ...val, dataVisible: true, msg: "" }));
      } else if (response.status === 401) {
        return navigate("/");

      } else if ([404, 500].includes(response.status)) {
        // error 500 o 404 not found
        setState((val) => ({ ...val, msg: data?.msg, notFound: true }));
      }

      setState((val) => ({ ...val, isLoading: false }));

    } catch (err) {
      console.log(err);
    }
  };


  // useEffect para solicitar la informacion al servidor
  useEffect(() => {

    if (user?.CodCliente) {
      fetchDataServ();
    }

    return () => {
      if (controller) {
        controller.abort();
      }
    };

  }, [user?.CodCliente, lang]);



  return {
    state,
    listServ,
    handleOpenCloseFilter
  }
};